import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause-home",
  "use": "icon-pause-home-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-pause-home\"><path d=\"M13.75 23.5h-1.5v-15h1.5v15Zm6 0h-1.5v-15h1.5v15Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol